export const getDisplayMode = () => {
  const mode = localStorage.getItem('display_mode') ? localStorage.getItem('display_mode') : "CARD"
  return mode
}